<ejs-grid #grid [dataSource]='datas' allowPaging="true" [pageSettings]='pageSettings'
          allowFiltering='true' [allowSelection]="true" [enableHover]="false"
          [filterSettings]='filterSettings' [selectionSettings]="selectOptions">
 
    <e-columns>
      <e-column type='checkbox' width='50'></e-column>
      <e-column field='Id' headerText='Id' isPrimaryKey='true'  width='0'></e-column>
      <e-column field='TenCauHoi' headerText='Tên câu hỏi' width='150'></e-column>
      <e-column field='NoiDung' headerText='Nội dung'></e-column>
      <e-column field='LoaiCauHoi' headerText='Loại câu hỏi' width='160'></e-column>
      <e-column field='MucDo' headerText='Mức độ khó' width='120'></e-column>
    </e-columns>
  </ejs-grid>
